import { NextPage } from 'next';

import { PromptListProvider } from '~/modules/prompts/providers/prompt-list';
import { PromptListPage } from '~/modules/prompts/pages/list';

const PromptsPage: NextPage = () => {
  return (
    <PromptListProvider>
      <PromptListPage />
    </PromptListProvider>
  );
};

export default PromptsPage;
